import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class WorkflowTransitionModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (WorkflowTransitionModel._instance == null) WorkflowTransitionModel._instance = new WorkflowTransitionModel(authManager);
        return WorkflowTransitionModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/workflow-transitions');

        this.entityName = 'core.WorkflowTransition';
        this.privileges = {
            create: [["adminWorkflow"]],
            read: [["#everyone"]],
            update: [["adminWorkflow"]],
            delete: [["adminWorkflow"]],
        };

        this.label = 'Workflow Transition';
        this.setLabel = 'Workflow Transitions';

        this.browser = {
            name: 'default-core-workflowtransition-browser',
            moduleName: 'default-core-workflowtransition-browser',
            moduleTitle: 'Workflow Transitions',
            moduleStateSlotName: 'default-core-workflowtransition-browser',
        };

        this.editor = {
            name: 'default-core-workflowtransition-editor',
            moduleName: 'default-core-workflowtransition-editor',
            moduleTitle: 'Workflow Transition',
            moduleStateSlotName: 'default-core-workflowtransition-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'workflowId',
                type: 'Workflow',
                persistent: true,
                label: 'Workflow',
            },
            {
                name: 'fromStatusId',
                type: 'WorkflowStatus',
                persistent: true,
                label: 'From State',
            },
            {
                name: 'toStatusId',
                type: 'WorkflowStatus',
                persistent: true,
                label: 'To State',
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
